import {ButtonGroup, Layout} from '@di-nxt/components';
import React, {useCallback, useMemo} from 'react';
import {t} from '../../../localization';
import {ScheduleCalendarType} from '../../../services';

type Props = {
  calendarType: ScheduleCalendarType;
  onCalendarTypeChange: (type: ScheduleCalendarType) => void;
};

export const ScheduleTypeSelector: React.FC<Props> = ({
  calendarType,
  onCalendarTypeChange,
}) => {
  const selectedIndex = useMemo(() => {
    if (calendarType === 'day') return 0;
    else if (calendarType === 'week') return 1;
    else return 2;
  }, [calendarType]);

  const handleCalendarTypeChanged = useCallback(
    (index: number) => {
      switch (index) {
        case 0: // Day
          onCalendarTypeChange('day');
          break;
        case 1: // Week
          onCalendarTypeChange('week');
          break;
        case 2: // Month
          onCalendarTypeChange('month');
          break;
      }
    },
    [onCalendarTypeChange],
  );
  return (
    <Layout horizontal>
      <ButtonGroup
        size="Small"
        hasBorders={false}
        selectedIndex={selectedIndex}
        onSelectedIndexChange={handleCalendarTypeChanged}
        items={[
          t('screens.schedule.calendarTypes.day'),
          t('screens.schedule.calendarTypes.week'),
          t('screens.schedule.calendarTypes.month'),
        ]}
      />
    </Layout>
  );
};
